 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTPRAISE from '@/components/Text/praise'
 import EBB from '@/components/ebb'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLE from '@/components/Text/title'
 import TEXT9780795344114_EPUB_FM_R1 from '@/components/Text/9780795344114_epub_fm_r1'
 import TEXT9780795344114_EPUB_DED_R1 from '@/components/Text/9780795344114_epub_ded_r1'
 import TEXT9780795344114_EPUB_FM1_R1 from '@/components/Text/9780795344114_epub_fm1_r1'
 import TEXT9780795344114_EPUB_PRO_R1 from '@/components/Text/9780795344114_epub_pro_r1'
 import TEXT9780795344114_EPUB_P01_R1 from '@/components/Text/9780795344114_epub_p01_r1'
 import TEXT9780795344114_EPUB_C01_R1 from '@/components/Text/9780795344114_epub_c01_r1'
 import TEXT9780795344114_EPUB_C02_R1 from '@/components/Text/9780795344114_epub_c02_r1'
 import TEXT9780795344114_EPUB_C03_R1 from '@/components/Text/9780795344114_epub_c03_r1'
 import TEXT9780795344114_EPUB_C04_R1 from '@/components/Text/9780795344114_epub_c04_r1'
 import TEXT9780795344114_EPUB_C05_R1 from '@/components/Text/9780795344114_epub_c05_r1'
 import TEXT9780795344114_EPUB_C06_R1 from '@/components/Text/9780795344114_epub_c06_r1'
 import TEXT9780795344114_EPUB_C07_R1 from '@/components/Text/9780795344114_epub_c07_r1'
 import TEXT9780795344114_EPUB_C08_R1 from '@/components/Text/9780795344114_epub_c08_r1'
 import TEXT9780795344114_EPUB_C09_R1 from '@/components/Text/9780795344114_epub_c09_r1'
 import TEXT9780795344114_EPUB_C10_R1 from '@/components/Text/9780795344114_epub_c10_r1'
 import TEXT9780795344114_EPUB_C11_R1 from '@/components/Text/9780795344114_epub_c11_r1'
 import TEXT9780795344114_EPUB_P02_R1 from '@/components/Text/9780795344114_epub_p02_r1'
 import TEXT9780795344114_EPUB_C12_R1 from '@/components/Text/9780795344114_epub_c12_r1'
 import TEXT9780795344114_EPUB_C13_R1 from '@/components/Text/9780795344114_epub_c13_r1'
 import TEXT9780795344114_EPUB_C14_R1 from '@/components/Text/9780795344114_epub_c14_r1'
 import TEXT9780795344114_EPUB_C15_R1 from '@/components/Text/9780795344114_epub_c15_r1'
 import TEXT9780795344114_EPUB_C16_R1 from '@/components/Text/9780795344114_epub_c16_r1'
 import TEXT9780795344114_EPUB_C17_R1 from '@/components/Text/9780795344114_epub_c17_r1'
 import TEXT9780795344114_EPUB_C18_R1 from '@/components/Text/9780795344114_epub_c18_r1'
 import TEXT9780795344114_EPUB_C19_R1 from '@/components/Text/9780795344114_epub_c19_r1'
 import TEXT9780795344114_EPUB_C20_R1 from '@/components/Text/9780795344114_epub_c20_r1'
 import TEXT9780795344114_EPUB_C21_R1 from '@/components/Text/9780795344114_epub_c21_r1'
 import TEXT9780795344114_EPUB_P03_R1 from '@/components/Text/9780795344114_epub_p03_r1'
 import TEXT9780795344114_EPUB_C22_R1 from '@/components/Text/9780795344114_epub_c22_r1'
 import TEXT9780795344114_EPUB_C23_R1 from '@/components/Text/9780795344114_epub_c23_r1'
 import TEXT9780795344114_EPUB_C24_R1 from '@/components/Text/9780795344114_epub_c24_r1'
 import TEXT9780795344114_EPUB_C25_R1 from '@/components/Text/9780795344114_epub_c25_r1'
 import TEXT9780795344114_EPUB_C26_R1 from '@/components/Text/9780795344114_epub_c26_r1'
 import TEXT9780795344114_EPUB_C27_R1 from '@/components/Text/9780795344114_epub_c27_r1'
 import TEXT9780795344114_EPUB_C28_R1 from '@/components/Text/9780795344114_epub_c28_r1'
 import TEXT9780795344114_EPUB_C29_R1 from '@/components/Text/9780795344114_epub_c29_r1'
 import TEXT9780795344114_EPUB_C30_R1 from '@/components/Text/9780795344114_epub_c30_r1'
 import TEXT9780795344114_EPUB_C31_R1 from '@/components/Text/9780795344114_epub_c31_r1'
 import TEXT9780795344114_EPUB_P04_R1 from '@/components/Text/9780795344114_epub_p04_r1'
 import TEXT9780795344114_EPUB_C32_R1 from '@/components/Text/9780795344114_epub_c32_r1'
 import TEXT9780795344114_EPUB_C33_R1 from '@/components/Text/9780795344114_epub_c33_r1'
 import TEXT9780795344114_EPUB_C34_R1 from '@/components/Text/9780795344114_epub_c34_r1'
 import TEXT9780795344114_EPUB_C35_R1 from '@/components/Text/9780795344114_epub_c35_r1'
 import TEXT9780795344114_EPUB_C36_R1 from '@/components/Text/9780795344114_epub_c36_r1'
 import TEXT9780795344114_EPUB_C37_R1 from '@/components/Text/9780795344114_epub_c37_r1'
 import TEXT9780795344114_EPUB_C38_R1 from '@/components/Text/9780795344114_epub_c38_r1'
 import TEXT9780795344114_EPUB_C39_R1 from '@/components/Text/9780795344114_epub_c39_r1'
 import TEXT9780795344114_EPUB_C40_R1 from '@/components/Text/9780795344114_epub_c40_r1'
 import TEXT9780795344114_EPUB_C41_R1 from '@/components/Text/9780795344114_epub_c41_r1'
 import TEXT9780795344114_EPUB_C42_R1 from '@/components/Text/9780795344114_epub_c42_r1'
 import TEXT9780795344114_EPUB_C43_R1 from '@/components/Text/9780795344114_epub_c43_r1'
 import TEXT9780795344114_EPUB_C44_R1 from '@/components/Text/9780795344114_epub_c44_r1'
 import TEXT9780795344114_EPUB_C45_R1 from '@/components/Text/9780795344114_epub_c45_r1'
 import TEXT9780795344114_EPUB_C46_R1 from '@/components/Text/9780795344114_epub_c46_r1'
 import LOVE_2 from '@/components/love_2'
 import PREVIEWPREVIEW from '@/components/Preview/preview'
 import PREVIEWPREVIEWCOVER from '@/components/Preview/previewcover'
 import PREVIEWC01 from '@/components/Preview/c01'
 import PREVIEWC02 from '@/components/Preview/c02'
 import PREVIEWC03 from '@/components/Preview/c03'
 import TEXT9780795344114_EPUB_END_R1 from '@/components/Text/9780795344114_epub_end_r1'
 import TEXT9780795344114_EPUB_BM_R1 from '@/components/Text/9780795344114_epub_bm_r1'
 import TEXTATA from '@/components/Text/ata'
 import TEXTCOPYRIGHT from '@/components/Text/Copyright'
 import BACKADSERIESBACKAD from '@/components/Backad/seriesbackad'
 import TEXTORIMAD from '@/components/Text/ORIM-ad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/Text/praise",
 			"name" : "Text/praise",
 			"component" : TEXTPRAISE
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/title",
 			"name" : "Text/title",
 			"component" : TEXTTITLE
 		},
 		{
 			"path" : "/Text/9780795344114_epub_fm_r1",
 			"name" : "Text/9780795344114_epub_fm_r1",
 			"component" : TEXT9780795344114_EPUB_FM_R1
 		},
 		{
 			"path" : "/Text/9780795344114_epub_ded_r1",
 			"name" : "Text/9780795344114_epub_ded_r1",
 			"component" : TEXT9780795344114_EPUB_DED_R1
 		},
 		{
 			"path" : "/Text/9780795344114_epub_fm1_r1",
 			"name" : "Text/9780795344114_epub_fm1_r1",
 			"component" : TEXT9780795344114_EPUB_FM1_R1
 		},
 		{
 			"path" : "/Text/9780795344114_epub_pro_r1",
 			"name" : "Text/9780795344114_epub_pro_r1",
 			"component" : TEXT9780795344114_EPUB_PRO_R1
 		},
 		{
 			"path" : "/Text/9780795344114_epub_p01_r1",
 			"name" : "Text/9780795344114_epub_p01_r1",
 			"component" : TEXT9780795344114_EPUB_P01_R1
 		},
 		{
 			"path" : "/Text/9780795344114_epub_c01_r1",
 			"name" : "Text/9780795344114_epub_c01_r1",
 			"component" : TEXT9780795344114_EPUB_C01_R1
 		},
 		{
 			"path" : "/Text/9780795344114_epub_c02_r1",
 			"name" : "Text/9780795344114_epub_c02_r1",
 			"component" : TEXT9780795344114_EPUB_C02_R1
 		},
 		{
 			"path" : "/Text/9780795344114_epub_c03_r1",
 			"name" : "Text/9780795344114_epub_c03_r1",
 			"component" : TEXT9780795344114_EPUB_C03_R1
 		},
 		{
 			"path" : "/Text/9780795344114_epub_c04_r1",
 			"name" : "Text/9780795344114_epub_c04_r1",
 			"component" : TEXT9780795344114_EPUB_C04_R1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js